<template>
  <v-container fluid>
    <h1>{{ $t('header.title') }}</h1>
    <v-spacer/>
    <h3 class="mt-2 mb-5">{{ $t('header.subtitle') }}</h3>
    <v-row>
      <v-col cols="2" :key="tournament.id" v-for="tournament in tournaments">
        <v-card @click="goToTournament(tournament)" class="overall-card d-flex align-center" outlined>
          <v-card-text class="pa-5">
            <div>
              <v-chip :color="tournamentStatusColor(tournament)" class="mb-2" small>{{ tournamentStatus(tournament) }}</v-chip>
              <h3 class="tournament-head">{{ truncateString(tournament.name) }}</h3>
              <p class="content mb-n2">{{ truncateString(tournament.creator.name, 50) }}</p>
            </div>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
    <v-divider class="my-7"/>
    <v-row>
      <v-col>
        <h3 style="cursor: pointer" @click="showNewTournamentWindow">
          <v-icon class="mr-2 mt-n1" small>fa-trophy</v-icon>{{ $t('callToAction') }}</h3>
      </v-col>
    </v-row>

    <!-- Overlay contact us for tournament creation !-->
    <v-overlay v-model="contactUsOverlay">
      <TournamentContactUs @closeWindow="contactUsOverlay = false"/>
    </v-overlay>
  </v-container>
</template>

<script>
import Repository from '../../../repositories/tournament';
import TournamentContactUs from "@/views/Tournament/components/TournamentContactUs";
export default {
  name: "TournamentHome",
  components: {TournamentContactUs},
  data() {
    return {
      tournaments: [],
      contactUsOverlay: false,
    };
  },
  mounted() {
    this.init();
  },
  methods: {
    init() {
      Repository.getPublicTournaments().then((response) => {
        if(response.status < 400)
          this.tournaments = response.data;
      });
    },
    tournamentVisibility(tournament) {
      return tournament.tournamentVisibility === 'PUBLIC'? this.$t('visibility.public') :
          tournament.tournamentVisibility === 'PRIVATE'? this.$t('visibility.private') : this.$t('visibility.exclusive');
    },
    tournamentStatus(tournament) {
      let now = new Date();
      if(new Date(tournament.endTime) < now)
        return this.$t('status.finished');
      else if(new Date(tournament.startTime) > now)
        return this.$t('status.planning');
      else
        return this.$t('status.running');
    },
    tournamentStatusColor(tournament) {
      let now = new Date();
      if(new Date(tournament.endTime) < now)
        return '#d1d1d1';
      else if(new Date(tournament.startTime) > now)
        return '#FFF75F';
      else
        return '#00F784';
    },
    goToTournament(tournament) {
      this.$router.push({
        name: 'tournament-overview',
        params: { tournamentId: Number.parseInt(tournament.id) }
      });
    },
    showNewTournamentWindow() {
      this.contactUsOverlay = true;
    },
    truncateString(string, maxLength) {
      return (string !== null && string.length > maxLength)? `${string.substring(0, maxLength)}...`: string;
    },
  }
}
</script>

<i18n>
{
  "en": {
    "header": {
      "title": "Tournaments",
      "subtitle": "Tournaments hosted by Swiset."
    },
    "visibility": {
      "public": "Public",
      "private": "Private",
      "exclusive": "Exclusive"
    },
    "status": {
      "planning": "Planning",
      "running": "Running",
      "finished": "Finished"
    },
    "callToAction": "Do you want to host/create a tournament through Swiset?"
  },
  "es": {
    "header": {
      "title": "Torneos",
      "subtitle": "Torneos creados a través de Swiset."
    },
    "visibility": {
      "public": "Público",
      "private": "Privado",
      "exclusive": "Exclusivo"
    },
    "status": {
      "planning": "Planeando",
      "running": "Corriendo",
      "finished": "Finalizado"
    },
    "callToAction": "¿Quieres crear/gestionar un torneo a través de Swiset?"
  }
}
</i18n>

<style lang="scss" scoped>
  @import "src/global";

  .tournament-head {
    color: $black-color;
    font-size: 25px;
  }
</style>
